import { useMediaQuery } from 'react-responsive';
import { useEffect } from 'react';
import { screenStore } from '../../stores/ScreenStore';

export const useUpdateScreenStates = () => {
  const isMobile = useMediaQuery({ maxWidth: 491 });
  const isTablet = useMediaQuery({ maxWidth: 680 });
  const isLaptop = useMediaQuery({ maxWidth: 849 });
  const isLaptopL = useMediaQuery({ maxWidth: 1019 });

  useEffect(() => {
    screenStore.setIsMobile(isMobile);
    screenStore.setIsTablet(isTablet);
    screenStore.setisLaptop(isLaptop);
    screenStore.setisLaptopL(isLaptopL);
  }, [isMobile, isTablet, isLaptop, isLaptopL]);
};